module.exports = __webpack_public_path__ + "img/icon_t1.c7a1ce50.png";